import React, { useState, useEffect } from "react";
import styles from "./Login.module.css";
import InputField from "../ui/InputField";
import Button from "../ui/Button";
import { useScreenSize } from "../auxiliaryFunctions";

const Login = ({ handleLogin, isLogin }) => {
  const { isMobile } = useScreenSize();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitted(true);

    if (!email) {
      setError("Пожалуйста, введите email");
      return;
    }

    if (!validateEmail(email)) {
      setError("Пожалуйста, введите корректный email");
      return;
    }

    // Если валидация прошла успешно
    setError("");
    handleLogin(email);
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    // Сбрасываем ошибку при изменении email
    if (error && isSubmitted) {
      setError("");
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.form}>
        <h1 className={styles.title}>Войти в аккаунт</h1>

        <p className={styles.welcomeText}>
          Чтобы войти, введите свою почту для получения кода доступа
        </p>

        <InputField
          type="email"
          label="Электронная почта"
          value={email}
          onChange={handleEmailChange}
          error={isSubmitted && error}
        />

        <div style={{ marginBottom: (isMobile ? "5px" : "20px") }}>
          <Button onClick={handleSubmit} label={"ВОЙТИ"} type="submit" isSaving={isLogin} isSavingLabel="ОТПРАВЛЯЕМ КОД" />
        </div>
        <p className={styles.policyP}>
          Осуществляя вход, вы соглашаетесь с <a
            href="/documents/policy.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.policyLink}
          >
           Политикой конфидиальности
          </a>
        </p>

      </div>
    </div>
  );
};

export default Login;